module.exports = __webpack_public_path__ + "img/instructions_v_a.e42a9fcf.png";